import { ApolloLink, Observable } from '@apollo/client';
import {
    getStoredNotifications,
    getUnreadCount,
    handleMarkAsRead,
    handleMarkAllAsRead,
    handleTogglePin,
    handleToggleMute
} from './mockHandlers';

const MOCKED_OPERATIONS = new Set([
    'GetUserNotifications',
    'GetUnreadCount',
    'MarkNotificationAsRead',
    'MarkAllNotificationsAsRead',
    'ToggleNotificationPin',
    'ToggleNotificationMute'
]);

export const createUserNotificationMockLink = () =>
    new ApolloLink((operation, forward) => {
        const operationName = operation.operationName;

        // Si la operación no está mockeada, pasa al backend real
        if (!MOCKED_OPERATIONS.has(operationName)) {
            return forward(operation);
        }

        // Interceptar y mockear
        return new Observable((observer) => {
            const delay = 300; // Simular latencia de red

            setTimeout(() => {
                try {
                    let result;

                    switch (operationName) {
                        case 'GetUserNotifications':
                            result = {
                                data: {
                                    getUserNotifications: {
                                        notifications: getStoredNotifications(),
                                        unreadCount: getUnreadCount(),
                                        total: getStoredNotifications().length
                                    }
                                }
                            };
                            break;

                        case 'GetUnreadCount':
                            result = {
                                data: {
                                    getUnreadCount: getUnreadCount()
                                }
                            };
                            break;

                        case 'MarkNotificationAsRead':
                            result = {
                                data: {
                                    markNotificationAsRead: handleMarkAsRead(operation.variables)
                                }
                            };
                            break;

                        case 'MarkAllNotificationsAsRead':
                            result = {
                                data: {
                                    markAllNotificationsAsRead: handleMarkAllAsRead()
                                }
                            };
                            break;

                        case 'ToggleNotificationPin':
                            result = {
                                data: {
                                    toggleNotificationPin: handleTogglePin(operation.variables)
                                }
                            };
                            break;

                        case 'ToggleNotificationMute':
                            result = {
                                data: {
                                    toggleNotificationMute: handleToggleMute(operation.variables)
                                }
                            };
                            break;

                        default:
                            observer.error({
                                graphQLErrors: [{ message: 'Operation not mocked' }]
                            });
                            return;
                    }

                    observer.next(result);
                    observer.complete();
                } catch (error: any) {
                    observer.error({
                        graphQLErrors: [{ message: error.message }]
                    });
                }
            }, delay);
        });
    });
